import { Component, Input } from '@angular/core';
import { NgClass } from "@angular/common";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[app-table-empty-state]',
  templateUrl: './table-empty-state.component.html',
  styleUrls: ['./table-empty-state.component.scss'],
  imports: [
    NgClass
],
})

/**
 * Component to display a "skeleton" loading state for table rows.
 *
 * This component creates a series of `<td>` elements with a pulsating effect to indicate loading.
 * The number of `<td>` elements is determined by the `tdAmount` input.
 *
 * The `blankSpaceIndices` input can be used to specify which `<td>` elements should be rendered as blank spaces.
 *
 * Example of usage:
 * ```html
 * <tr *ngFor="let i of [].constructor(selectedOrg?.funds?.length)"
 *     app-table-empty-state
 *     class="tr-empty-state"
 *     [tdAmount]="10"
 *     [blankSpaceIndices]="[2, 4, 6]">
 * </tr>
 * ```
 */
export class TableRowEmptyStateComponent {
  @Input() tdAmount = 1;
  @Input() blankSpaceIndices: number[] = [];
}
